module.exports = __webpack_public_path__ + "static/netflix-tudum-6-78860121532c3630257f0dbd3f80b7c8.jpg";